"use strict";
const CONSTANTS = {
  GRID_SIZE: 20,
  DRAG_POINT_RADIUS: 8,
  BOUNDING_BOX_PADDING: 4
};
export const { GRID_SIZE, DRAG_POINT_RADIUS } = CONSTANTS;
export default CONSTANTS;
